module.exports = __webpack_public_path__ + "static/img/icon-3.eefbfe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-1/icon-3.png
// module id = oHSc
// module chunks = 0